import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PreLessonValues } from "@live-writing/models";



interface PreLessonStore {
  lessons: PreLessonValues[];
  isLoading: boolean;
  addLesson: (lesson: PreLessonValues) => PreLessonValues;
  updateLesson: (id: number, updates: Partial<PreLessonValues>) => void;
  deleteLesson: (id: number) => void;
  getLesson: (id: number) => PreLessonValues | undefined;
}

export const usePreLessonStore = create<PreLessonStore>()(
  persist(
    (set, get) => ({
      lessons: [],
      isLoading: true,

      addLesson: (lesson) => {
        set((state) => ({
          lessons: [lesson, ...state.lessons],
        }));

        return lesson;
      },

      updateLesson: (id: number, updates: Partial<PreLessonValues>) => {
        set((state) => ({
          lessons: state.lessons.map((lesson) =>
            lesson.id === id
              ? { ...lesson, ...updates, updated_at: new Date() }
              : lesson
          ),
        }));
      },

      deleteLesson: (id: number) => {
        set((state) => ({
          lessons: state.lessons.filter((lesson) => lesson.id !== id),
        }));
      },

      getLesson: (id: number) => {
        return get().lessons.find((lesson) => lesson.id === id);
      },
    }),
    {
      name: "pre_lessons",
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.isLoading = false;
        }
      },
    }
  )
);
